import React from 'react';

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, totalSteps }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 28 }}>
    <div style={{ display: 'flex', gap: 6, flex: 1 }}>
      {Array.from({ length: totalSteps }).map((_, i) => (
        <div
          key={i}
          style={{
            height: 4,
            flex: 1,
            borderRadius: 999,
            background: i < currentStep ? 'var(--ember)' : 'var(--border)',
          }}
        />
      ))}
    </div>
    <span className="ws-mono" style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--text-tertiary)', whiteSpace: 'nowrap' }}>
      {currentStep} of {totalSteps}
    </span>
  </div>
);

export default StepIndicator;
